import { createClient } from "@supabase/supabase-js";
import type { Database } from "@/types/database";

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error("Missing Supabase environment variables");
}

// Helper function to get the correct site URL for redirects
export const getSiteUrl = () => {
  // In development, use localhost
  if (window.location.hostname === 'localhost') {
    return window.location.origin;
  }
  
  // In production, use the deployed URL
  return 'https://trykrak.vercel.app';
};

// Initialize Supabase client with optimized settings
export const supabase = createClient<Database>(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    detectSessionInUrl: true,
    autoRefreshToken: true,
    flowType: 'implicit',
    storage: localStorage,
    storageKey: 'krak-auth-token',
    // Set a longer expiration time (90 days in seconds)
    cookieOptions: {
      maxAge: 60 * 60 * 24 * 90,
      sameSite: 'lax',
      secure: window.location.protocol === 'https:',
    },
  },
  realtime: {
    params: {
      eventsPerSecond: 2,
    },
  },
});
